import { useState, useCallback } from "react";
import { useFormStatus, FORM_STATUS } from "../../contexts/form-status-provider.js";
import { SignatureMode, SignatureFormat, SignatureView } from "./signature-types.js";
import { useSignatureValue } from "./use-signature-value.js";
const useSignatureField = ({
  target,
  value,
  onChange
}) => {
  const { handleChange, cancelUpload, signature, decodedValue } = useSignatureValue({
    value,
    onChange,
    target
  });
  const [signatureMode, setSignatureMode] = useState(() => {
    if (signature == null) {
      return SignatureMode.DRAW;
    }
    switch (decodedValue?.mimeType) {
      case SignatureFormat.POINTS:
        return SignatureMode.DRAW;
      case SignatureFormat.TEXT:
        return SignatureMode.TYPE;
      default:
        return SignatureMode.UPLOAD;
    }
  });
  const { setFormStatus } = useFormStatus();
  const handleBeforeChange = useCallback(() => {
    cancelUpload();
    setFormStatus(target, FORM_STATUS.BUSY);
  }, [cancelUpload, setFormStatus, target]);
  const handleClear = useCallback(() => {
    cancelUpload();
    handleChange(null);
    setFormStatus(target, FORM_STATUS.READY);
  }, [cancelUpload, handleChange, setFormStatus, target]);
  const clearable = signature != null;
  const signatureValueForView = undefinedIfUnsupportedByCurrentMode(
    signatureMode,
    signature,
    decodedValue
  );
  const signatureView = (() => {
    switch (signatureMode) {
      case SignatureMode.DRAW:
        return SignatureView.DRAW;
      case SignatureMode.TYPE:
        return SignatureView.TYPE;
      case SignatureMode.UPLOAD:
        return signatureValueForView != null ? SignatureView.IMAGE : SignatureView.UPLOAD;
      default:
        return SignatureView.DRAW;
    }
  })();
  return {
    signature,
    decodedValue,
    signatureMode,
    clearable,
    signatureValueForView,
    signatureView,
    handleChange,
    setSignatureMode,
    handleBeforeChange,
    handleClear
  };
};
const ACCEPTED_FORMATS_BY_MODE = {
  [SignatureMode.DRAW]: (decodedValue) => decodedValue?.mimeType === SignatureFormat.POINTS,
  [SignatureMode.TYPE]: (decodedValue) => decodedValue?.mimeType === SignatureFormat.TEXT,
  [SignatureMode.UPLOAD]: (decodedValue) => decodedValue?.mimeType !== SignatureFormat.POINTS && decodedValue?.mimeType !== SignatureFormat.TEXT
};
function undefinedIfUnsupportedByCurrentMode(mode, signature, decodedValue) {
  if (!signature) {
    return void 0;
  }
  const isAcceptedFormat = ACCEPTED_FORMATS_BY_MODE[mode](decodedValue);
  return isAcceptedFormat ? signature : void 0;
}
export {
  useSignatureField
};
//# sourceMappingURL=use-signature-field.js.map
